// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.Header_header__FeuvY {
  --primary: #82B194;
  position: sticky;
  top: 0;
  z-index: 100;
  background: #F7F5F1;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(19, 35, 29, 0.05);
  width: 100%;
}
.Header_header--scrolled__83-LZ {
  background: rgba(247, 245, 241, 0.86);
  border-bottom-color: rgba(19, 35, 29, 0.07);
  box-shadow: 0 12px 30px rgba(18, 34, 29, 0.055);
  backdrop-filter: blur(14px) saturate(1.04);
  -webkit-backdrop-filter: blur(14px) saturate(1.04);
}
.Header_header-inner__pcjDB {
  width: min(100%, 1280px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) 388px;
  align-items: center;
  column-gap: 44px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 40px;
  padding-right: 16px;
}
@media (max-width: 1200px) {
  .Header_header-inner__pcjDB {
    display: flex;
    justify-content: space-between;
    padding: 14px 20px;
  }
}
@media (max-width: 1100px) {
  .Header_header-inner__pcjDB {
    padding-left: 12px;
    padding-right: 12px;
  }
}
@media (max-width: 760px) {
  .Header_header-inner__pcjDB {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.Header_header__FeuvY {
  /* 2. LOGOTIPO */
}
.Header_header__FeuvY .Header_logo__ybdca {
  display: flex;
  align-items: center;
  justify-self: start;
}
.Header_header__FeuvY .Header_logo__ybdca img {
  height: 42px;
  width: auto;
}
.Header_header__FeuvY {
  /* 3. NAVEGACIÓN PRINCIPAL */
}
.Header_header__FeuvY .Header_nav__Mqis- {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  gap: 24px;
  flex-wrap: nowrap;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav__Mqis- {
    position: fixed;
    top: 0;
    right: 0;
    width: 300px;
    height: 100vh;
    background: #F7F5F1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px;
    gap: 0;
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.05);
    transform: translateX(100%);
    visibility: hidden;
    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.4s;
    z-index: 1001;
    overflow-y: auto;
  }
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav--is-open__PHi\\+x {
    transform: translateX(0);
    visibility: visible;
  }
}
.Header_header__FeuvY .Header_nav-header__K6eYQ {
  display: none;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-header__K6eYQ {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 24px;
  }
  .Header_header__FeuvY .Header_nav-header__K6eYQ .Header_logo__ybdca img {
    height: 34px;
  }
}
.Header_header__FeuvY .Header_nav-close__n1hSo {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #13231D;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Header_header__FeuvY .Header_nav-links__jOVzi {
  display: flex;
  align-items: center;
  gap: 24px;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-links__jOVzi {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 4px !important;
  }
}
.Header_header__FeuvY .Header_nav-link__1ybBU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 4px;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.2;
  color: #13231D;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  background: none;
  font-family: inherit;
  transition: all 0.2s ease;
  text-decoration: none;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-link__1ybBU {
    width: 100%;
    justify-content: flex-start;
    font-size: 17px;
    padding: 14px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
    color: #13231D !important;
    border-radius: 0;
  }
}
.Header_header__FeuvY .Header_nav__Mqis- {
  /* DROPDOWN DE COMUNIDAD */
}
.Header_header__FeuvY .Header_nav-dropdown__bUHwl {
  position: relative;
  display: inline-block;
  width: 118px !important;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-dropdown__bUHwl {
    width: 100% !important;
  }
}
@media (min-width: 1201px) and (pointer: fine) {
  .Header_header__FeuvY .Header_nav-dropdown__bUHwl:hover .Header_nav-trigger__cKz-P .Header_arrow-icon__Yx1Uf {
    transform: rotate(180deg);
  }
  .Header_header__FeuvY .Header_nav-dropdown__bUHwl:hover .Header_nav-menu__L734q {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
}
.Header_header__FeuvY .Header_nav-trigger__cKz-P {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 4px;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.2;
  color: #13231D;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  border: none;
  background: none;
  font-family: inherit;
  transition: all 0.2s ease;
}
.Header_header__FeuvY .Header_nav-trigger__cKz-P .Header_arrow-icon__Yx1Uf {
  font-size: 18px !important;
  transition: transform 0.2s ease;
  opacity: 0.7;
}
.Header_header__FeuvY .Header_nav-trigger--active__V6ATq .Header_arrow-icon__Yx1Uf {
  transform: rotate(180deg);
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-trigger__cKz-P {
    width: 100%;
    justify-content: space-between;
    font-size: 17px;
    padding: 14px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  }
}
.Header_header__FeuvY .Header_nav-menu__L734q {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  width: 240px;
  background: #F7F5F1;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(18, 34, 29, 0.08);
  border: 1px solid rgba(19, 35, 29, 0.05);
  padding: 8px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;
}
.Header_header__FeuvY .Header_nav-menu--open__CAOck {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
.Header_header__FeuvY .Header_nav-menu__L734q a,
.Header_header__FeuvY .Header_nav-menu__L734q button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  color: #13231D;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.Header_header__FeuvY .Header_nav-menu__L734q a:hover,
.Header_header__FeuvY .Header_nav-menu__L734q button:hover {
  background-color: rgba(130, 177, 148, 0.06) !important;
  color: #82B194 !important;
}
@media (pointer: coarse) {
  .Header_header__FeuvY .Header_nav-menu__L734q {
    position: static;
    transform: none;
    width: 100%;
    box-shadow: none;
    border: none;
    background: transparent;
    padding: 0 0 0 16px;
    height: 0;
    overflow: hidden;
    transition: height 0.25s ease, padding 0.25s ease;
  }
  .Header_header__FeuvY .Header_nav-menu--open__CAOck {
    height: auto;
    transform: none;
    padding-top: 4px;
    padding-bottom: 8px;
  }
  .Header_header__FeuvY .Header_nav-menu__L734q a,
  .Header_header__FeuvY .Header_nav-menu__L734q button {
    font-size: 15px;
    padding: 10px 0;
    border-bottom: none;
  }
  .Header_header__FeuvY .Header_nav-menu__L734q a:hover,
  .Header_header__FeuvY .Header_nav-menu__L734q button:hover {
    background-color: transparent !important;
  }
}
.Header_header__FeuvY .Header_nav__Mqis- {
  /* Vistas responsivas en Drawer */
}
.Header_header__FeuvY .Header_nav-footer__nFxCH {
  display: none;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_nav-footer__nFxCH {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    gap: 20px;
  }
}
.Header_header__FeuvY .Header_nav-mobile-lang__Iq7qz {
  display: flex;
  gap: 12px;
}
.Header_header__FeuvY .Header_nav-lang-btn__SFf5A {
  flex: 1 1;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(130, 177, 148, 0.2);
  background: transparent;
  color: #13231D;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.Header_header__FeuvY .Header_nav-lang-btn--active__nhoPp {
  background: rgba(130, 177, 148, 0.1);
  border-color: #82B194;
  color: #82B194;
}
.Header_header__FeuvY .Header_nav-mobile-user__nEFhH {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.Header_header__FeuvY .Header_nav-user-info__cZfFm {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  min-width: 0;
}
.Header_header__FeuvY .Header_nav-user-icon__yTb5w {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  max-width: 48px;
  max-height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  font-size: 48px !important;
}
.Header_header__FeuvY .Header_nav-user-details__MwyYi {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
}
.Header_header__FeuvY .Header_nav-user-name__i8yu9 {
  font-weight: 800;
  font-size: 16px;
  color: #13231D;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Header_header__FeuvY .Header_nav-user-email__yOIjh {
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Header_header__FeuvY .Header_nav-user-actions__QorZB {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Header_header__FeuvY .Header_nav-user-link__JKd2j {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 15px;
  color: #13231D;
  text-decoration: none;
  transition: background 0.2s;
}
.Header_header__FeuvY .Header_nav-user-link__JKd2j svg {
  font-size: 20px;
}
.Header_header__FeuvY .Header_nav-user-link__JKd2j:hover {
  background: rgba(130, 177, 148, 0.05);
}
.Header_header__FeuvY .Header_nav-logout__O9RXz {
  border: none;
  background: transparent;
  width: 100%;
  color: #13231D;
  justify-content: center;
}
.Header_header__FeuvY .Header_nav-logout__O9RXz:hover {
  background: #FEF2F2 !important;
}
.Header_header__FeuvY .Header_nav-mobile-auth__monXU {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Header_header__FeuvY .Header_nav-login-btn__kewKo {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  font-weight: 700;
  color: #13231D;
  text-decoration: none;
  font-size: 15px;
}
.Header_header__FeuvY .Header_actions__PwT9E {
  width: 388px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  justify-self: end;
  gap: 22px;
  white-space: nowrap;
}
@media (max-width: 1100px) {
  .Header_header__FeuvY .Header_actions__PwT9E {
    width: 348px;
    gap: 18px;
  }
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_actions__PwT9E {
    display: none;
  }
}
.Header_header__FeuvY .Header_lang-switch__YVhli {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 5px;
  padding-right: 0px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #13231D;
  font-weight: 600;
  font-size: 15px;
}
.Header_header__FeuvY .Header_lang-switch__YVhli img {
  width: 16px;
  height: 16px;
  opacity: 0.78;
}
.Header_header__FeuvY .Header_lang-switch--active__Fj\\+lZ {
  background: rgba(130, 177, 148, 0.08);
}
.Header_header__FeuvY {
  /* Enlace Acceder */
}
.Header_header__FeuvY .Header_login-link__4mZg1 {
  font-size: 16px;
  line-height: 1.2;
  color: #13231D;
  font-weight: 600;
  text-decoration: none;
}
.Header_header__FeuvY {
  /* Botones principales y CTA */
}
.Header_header__FeuvY .Header_header-btn__\\+OQjl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 20px;
  border-radius: 16px;
  background: transparent;
  border: 1px solid rgba(130, 177, 148, 0.95);
  color: #82B194;
  font-weight: 600;
  font-size: 15px;
  text-decoration: none;
  transition: all 0.24s ease;
  line-height: 1;
}
.Header_header__FeuvY .Header_header-btn__\\+OQjl:hover {
  background: rgba(130, 177, 148, 0.1);
  box-shadow: 0 8px 20px rgba(130, 177, 148, 0.12);
  transform: translateY(-1px);
}
.Header_header__FeuvY {
  /* 5. REGLAS DE INTERACCIÓN VISUAL EN V6 (HOVER LIMPIO Y PLANO) */
}
.Header_header__FeuvY .Header_nav__Mqis- a:hover, .Header_header__FeuvY .Header_nav__Mqis- a:focus-visible, .Header_header__FeuvY .Header_login-link__4mZg1:hover, .Header_header__FeuvY .Header_login-link__4mZg1:focus-visible, .Header_header__FeuvY .Header_lang-switch__YVhli:hover, .Header_header__FeuvY .Header_lang-switch__YVhli:focus-visible, .Header_header__FeuvY .Header_header-btn__\\+OQjl:hover, .Header_header__FeuvY .Header_header-btn__\\+OQjl:focus-visible {
  color: var(--primary) !important;
  background: transparent !important;
  box-shadow: none !important;
  transform: none !important;
  text-decoration: none !important;
}
.Header_header__FeuvY {
  /* Botón Toggler para responsivo */
}
.Header_header__FeuvY .Header_toggler__n58hD {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: none;
  color: #13231D;
}
@media (max-width: 1200px) {
  .Header_header__FeuvY .Header_toggler__n58hD {
    display: flex;
    align-items: center;
  }
}
.Header_header__overlay__Hd0\\+k {
  position: fixed;
  inset: 0;
  background: rgba(19, 35, 29, 0.78);
  backdrop-filter: blur(4px);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  pointer-events: none;
}
.Header_header__overlay--is-open__AXCef {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  height: 100dvh;
}
.Header_header__FeuvY {
  /* Elemento contenedor para dropdowns de acciones */
}
.Header_header__FeuvY .Header_action-item__EAl9X {
  position: relative;
}
.Header_header__FeuvY {
  /* Botón de Perfil de Usuario Logueado */
}
.Header_header__FeuvY .Header_profile-btn__wfMXZ {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 6px 12px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #13231D;
}
.Header_header__FeuvY .Header_profile-btn--active__GenK8 {
  background: rgba(130, 177, 148, 0.08);
}
.Header_header__FeuvY .Header_profile-icon__x5\\+9K {
  font-size: 24px !important;
}
.Header_header__FeuvY .Header_profile-name__rlWPA {
  font-weight: 700;
  font-size: 15px;
}
.Header_header__FeuvY .Header_arrow__MMgpm {
  transition: transform 0.2s ease;
  font-size: 20px !important;
  opacity: 0.7;
}
.Header_header__FeuvY .Header_arrow--open__jQ3Rw {
  transform: rotate(180deg);
}
.Header_header__FeuvY {
  /* Dropdowns de usuario / idioma generales */
}
.Header_header__FeuvY .Header_dropdown__gG71Y {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 273px;
  background: #F7F5F1;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(18, 34, 29, 0.12);
  border: 1px solid rgba(19, 35, 29, 0.06);
  padding: 5px;
  z-index: 1000;
  transform-origin: top right;
  animation: Header_dropdownFadeIn__wCOVE 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.Header_header__FeuvY .Header_dropdown--lang__sNo60 {
  width: 190px;
}
.Header_header__FeuvY .Header_dropdown-header__Zw7E8 {
  padding: 12px 16px;
}
.Header_header__FeuvY .Header_dropdown-user-name__e0cFO {
  margin: 0;
  font-weight: 800;
  font-size: 13px;
  color: #13231D;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1;
}
.Header_header__FeuvY .Header_dropdown-user-email__ORM7z {
  margin: 2px 0 0;
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.Header_header__FeuvY .Header_dropdown-divider__Grbiz {
  height: 1px;
  background: rgba(19, 35, 29, 0.06);
  margin: 8px 0;
}
.Header_header__FeuvY .Header_dropdown-item__gvbii {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  text-decoration: none;
  color: #13231D;
  font-size: 14px;
  font-weight: 600;
  border-radius: 14px;
  border: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
}
.Header_header__FeuvY .Header_dropdown-item--active__4k9vZ {
  color: #82B194 !important;
}
.Header_header__FeuvY .Header_dropdown-item--active__4k9vZ .Header_dropdown-icon-wrapper__wArFJ {
  color: #82B194;
}
.Header_header__FeuvY .Header_dropdown-item__gvbii:hover {
  background: rgba(130, 177, 148, 0.06);
}
.Header_header__FeuvY .Header_dropdown-item--logout__QrEve:hover {
  background: rgba(130, 177, 148, 0.06);
}
.Header_header__FeuvY .Header_dropdown-item--logout__QrEve:hover .Header_dropdown-icon-wrapper__wArFJ {
  color: #EF4444;
}
.Header_header__FeuvY .Header_dropdown-item__gvbii span {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Header_header__FeuvY .Header_dropdown-icon-wrapper__wArFJ {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.Header_header__FeuvY .Header_dropdown-icon-wrapper__wArFJ svg {
  font-size: 22px !important;
}

@keyframes Header_dropdownFadeIn__wCOVE {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Landing/Header/Header.module.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACyIhB;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AD5IJ;;AAfA;EACE,kBAAA;EAEA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,mBCWqB;EDVrB,2BAAA;EACA,mCAAA;EACA,+CAAA;EACA,WAAA;AAiBF;AAXE;EACE,qCAAA;EACA,2CAAA;EACA,+CAAA;EACA,0CAAA;EACA,kDAAA;AAaJ;AAVE;EACE,wBAAA;EACA,cAAA;EACA,aAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAYJ;AAVI;EAZF;IAaI,aAAA;IACA,8BAAA;IACA,kBAAA;EAaJ;AACF;AAXI;EAlBF;IAmBI,kBAAA;IACA,mBAAA;EAcJ;AACF;AAZI;EAvBF;IAwBI,iBAAA;IACA,oBAAA;EAeJ;AACF;AAjEA;EAqDE,gBAAA;AAeF;AAdE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAgBJ;AAdI;EACE,YAAA;EACA,WAAA;AAgBN;AA7EA;EAiEE,4BAAA;AAeF;AAdE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;AAgBJ;AAdI;EATF;IAUI,eAAA;IACA,MAAA;IACA,QAAA;IACA,YAAA;IACA,aAAA;IACA,mBChEiB;IDiEjB,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,aAAA;IACA,MAAA;IACA,4CAAA;IACA,2BAAA;IACA,kBAAA;IACA,yEAAA;IACA,aAAA;IACA,gBAAA;EAiBJ;AACF;AAdM;EADF;IAEI,wBAAA;IACA,mBAAA;EAiBN;AACF;AAdI;EACE,aAAA;AAgBN;AAdM;EAHF;IAII,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,WAAA;IACA,mBAAA;EAiBN;EAfM;IACE,YAAA;EAiBR;AACF;AAbI;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cCrGiB;EDsGjB,aAAA;EACA,mBAAA;EACA,uBAAA;AAeN;AAZI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAcN;AAZM;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;EAeN;AACF;AAZI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCjIiB;EDkIjB,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;AAcN;AAZM;EAlBF;IAmBI,WAAA;IACA,2BAAA;IACA,eAAA;IACA,eAAA;IACA,4CAAA;IACA,yBAAA;IACA,gBAAA;EAeN;AACF;AArHE;EAyGE,0BAAA;AAeJ;AAdI;EACE,kBAAA;EACA,qBAAA;EACA,uBAAA;AAgBN;AAdM;EALF;IAMI,sBAAA;EAiBN;AACF;AAfM;EAEI;IACE,yBAAA;EAgBV;EAbQ;IACE,UAAA;IACA,mBAAA;IACA,yCAAA;EAeV;AACF;AAVI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCvLiB;EDwLjB,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;AAYN;AAVM;EACE,0BAAA;EACA,+BAAA;EACA,YAAA;AAYR;AATM;EACE,yBAAA;AAWR;AARM;EA5BF;IA6BI,WAAA;IACA,8BAAA;IACA,eAAA;IACA,eAAA;IACA,4CAAA;EAWN;AACF;AARI;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,4CAAA;EACA,YAAA;EACA,mBC9NiB;ED+NjB,mBAAA;EACA,8CAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,sEAAA;AAUN;AARM;EACE,UAAA;EACA,mBAAA;EACA,yCAAA;AAUR;AAPM;;EAEE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,cC/Oe;EDgPf,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uDAAA;AASR;AAPQ;;EACE,sDAAA;EACA,yBAAA;AAUV;AANM;EA5CF;IA6CI,gBAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,uBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;IACA,iDAAA;EASN;EAPM;IACE,YAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EASR;EANM;;IAEE,eAAA;IACA,eAAA;IACA,mBAAA;EAQR;EANQ;;IACE,wCAAA;EASV;AACF;AAvPE;EAmPE,iCAAA;AAOJ;AANI;EACE,aAAA;AAQN;AANM;EAHF;IAII,aAAA;IACA,sBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,yCAAA;IACA,SAAA;EASN;AACF;AANI;EACE,aAAA;EACA,SAAA;AAQN;AALI;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,uBAAA;EACA,cCzTiB;ED0TjB,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAON;AALM;EACE,oCAAA;EACA,qBC9Ue;ED+Uf,cC/Ue;ADsVvB;AAHI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKN;AAFI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,4CAAA;EACA,YAAA;AAIN;AADI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AAGN;AAAI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AAEN;AACI;EACE,gBAAA;EACA,eAAA;EACA,cC7WiB;ED8WjB,mBAAA;EACA,gBAAA;EACA,uBAAA;AACN;AAEI;EACE,eAAA;EACA,6BCnXiB;EDoXjB,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCzYiB;ED0YjB,qBAAA;EACA,2BAAA;AAFN;AAIM;EACE,eAAA;AAFR;AAKM;EACE,qCAAA;AAHR;AAOI;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,cC1ZiB;ED2ZjB,uBAAA;AALN;AAOM;EACE,8BAAA;AALR;AASI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAPN;AAUI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cC9aiB;ED+ajB,qBAAA;EACA,eAAA;AARN;AAYE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;AAVJ;AAYI;EATF;IAUI,YAAA;IACA,SAAA;EATJ;AACF;AAWI;EAdF;IAeI,aAAA;EARJ;AACF;AAWE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cCldmB;EDmdnB,gBAAA;EACA,eAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,aAAA;AATN;AAYI;EACE,qCAAA;AAVN;AAzeA;EAufE,mBAAA;AAXF;AAYE;EACE,eAAA;EACA,gBAAA;EACA,cCremB;EDsenB,gBAAA;EACA,qBAAA;AAVJ;AAnfA;EAggBE,8BAAA;AAVF;AAWE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,cCjgBmB;EDkgBnB,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,cAAA;AATJ;AAWI;EACE,oCAAA;EACA,gDAAA;EACA,2BAAA;AATN;AA3gBA;EAwhBE,iEAAA;AAVF;AAWE;EAQE,gCAAA;EACA,kCAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;AAhBJ;AArhBA;EAwiBE,kCAAA;AAhBF;AAiBE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,cCzhBmB;AD0gBvB;AAiBI;EARF;IASI,aAAA;IACA,mBAAA;EAdJ;AACF;AAiBE;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;AAfJ;AAiBI;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AAfN;AAvjBA;EA0kBE,mDAAA;AAhBF;AAiBE;EACE,kBAAA;AAfJ;AA7jBA;EA+kBE,wCAAA;AAfF;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cCpkBmB;ADsjBvB;AAgBI;EACE,qCAAA;AAdN;AAkBE;EACE,0BAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,0BAAA;EACA,YAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;AA9lBA;EAonBE,4CAAA;AAnBF;AAoBE;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,mBCzmBmB;ED0mBnB,mBAAA;EACA,8CAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,2EAAA;AAlBJ;AAoBI;EACE,YAAA;AAlBN;AAqBI;EACE,kBAAA;AAnBN;AAsBI;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cCznBiB;ED0nBjB,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AApBN;AAuBI;EACE,eAAA;EACA,eAAA;EACA,6BCjoBiB;EDkoBjB,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AArBN;AAwBI;EACE,WAAA;EACA,kCAAA;EACA,aAAA;AAtBN;AAyBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,cCtpBiB;EDupBjB,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAvBN;AAyBM;EACE,yBAAA;AAvBR;AAyBQ;EACE,cCjrBa;AD0pBvB;AA2BM;EACE,qCAAA;AAzBR;AA8BQ;EACI,qCAAA;AA5BZ;AA8BU;EACE,cAAA;AA5BZ;AAiCM;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/BR;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAjCN;AAmCM;EACE,0BAAA;AAjCR;;AAuCA;EACE;IACE,UAAA;IACA,2BAAA;EApCF;EAuCA;IACE,UAAA;IACA,wBAAA;EArCF;AACF","sourcesContent":["@import '../../../assets/styles/variables';\n\n.header {\n  --primary: #{$color-primary};\n\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: $color-surface;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-bottom: 1px solid rgba(19, 35, 29, 0.05);\n  width: 100%;\n\n  // &--is-menu-open {\n  //   z-index: 2000;\n  // }\n\n  &--scrolled {\n    background: rgba(247, 245, 241, 0.86);\n    border-bottom-color: rgba(19, 35, 29, 0.07);\n    box-shadow: 0 12px 30px rgba(18, 34, 29, 0.055);\n    backdrop-filter: blur(14px) saturate(1.04);\n    -webkit-backdrop-filter: blur(14px) saturate(1.04);\n  }\n\n  &-inner {\n    width: min(100%, $base-container);\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 220px minmax(0, 1fr) 388px;\n    align-items: center;\n    column-gap: 44px;\n    padding-top: 14px;\n    padding-bottom: 14px;\n    padding-left: 40px;\n    padding-right: 16px;\n\n    @media (max-width: 1200px) {\n      display: flex;\n      justify-content: space-between;\n      padding: 14px 20px;\n    }\n\n    @media (max-width: 1100px) {\n      padding-left: 12px;\n      padding-right: 12px;\n    }\n\n    @media (max-width: 760px) {\n      padding-top: 10px;\n      padding-bottom: 10px;\n    }\n  }\n\n  /* 2. LOGOTIPO */\n  .logo {\n    display: flex;\n    align-items: center;\n    justify-self: start;\n\n    img {\n      height: 42px;\n      width: auto;\n    }\n  }\n\n  /* 3. NAVEGACIÓN PRINCIPAL */\n  .nav {\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    justify-self: center;\n    gap: 24px;\n    flex-wrap: nowrap;\n\n    @media (max-width: 1200px) {\n      position: fixed;\n      top: 0;\n      right: 0;\n      width: 300px;\n      height: 100vh;\n      background: $color-surface;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      padding: 24px;\n      gap: 0;\n      box-shadow: -10px 0 30px rgba(0, 0, 0, 0.05);\n      transform: translateX(100%);\n      visibility: hidden;\n      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), visibility 0.4s;\n      z-index: 1001;\n      overflow-y: auto;\n    }\n\n    &--is-open {\n      @media (max-width: 1200px) {\n        transform: translateX(0);\n        visibility: visible;\n      }\n    }\n\n    &-header {\n      display: none;\n\n      @media (max-width: 1200px) {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        margin-bottom: 24px;\n\n        .logo img {\n          height: 34px;\n        }\n      }\n    }\n\n    &-close {\n      background: none;\n      border: none;\n      padding: 0;\n      cursor: pointer;\n      color: $text-main;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    &-links {\n      display: flex;\n      align-items: center;\n      gap: 24px;\n\n      @media (max-width: 1200px) {\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n        gap: 4px !important;\n      }\n    }\n\n    &-link {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 40px;\n      padding: 0 4px;\n      white-space: nowrap;\n      font-size: 16px;\n      line-height: 1.2;\n      color: $text-main;\n      font-weight: 600;\n      border-radius: 12px;\n      border: none;\n      background: none;\n      font-family: inherit;\n      transition: all 0.2s ease;\n      text-decoration: none;\n\n      @media (max-width: 1200px) {\n        width: 100%;\n        justify-content: flex-start;\n        font-size: 17px;\n        padding: 14px 0;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n        color: $text-main !important;\n        border-radius: 0;\n      }\n    }\n\n    /* DROPDOWN DE COMUNIDAD */\n    &-dropdown {\n      position: relative;\n      display: inline-block;\n      width: 118px !important;\n\n      @media (max-width: 1200px) {\n        width: 100% !important;\n      }\n\n      @media (min-width: 1201px) and (pointer: fine) {\n        &:hover {\n          .nav-trigger .arrow-icon {\n            transform: rotate(180deg);\n          }\n\n          .nav-menu {\n            opacity: 1;\n            visibility: visible;\n            transform: translateX(-50%) translateY(0);\n          }\n        }\n      }\n    }\n\n    &-trigger {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      min-height: 40px;\n      padding: 0 4px;\n      white-space: nowrap;\n      font-size: 16px;\n      line-height: 1.2;\n      color: $text-main;\n      font-weight: 600;\n      text-decoration: none;\n      cursor: pointer;\n      border: none;\n      background: none;\n      font-family: inherit;\n      transition: all 0.2s ease;\n\n      .arrow-icon {\n        font-size: 18px !important;\n        transition: transform 0.2s ease;\n        opacity: 0.7;\n      }\n\n      &--active .arrow-icon {\n        transform: rotate(180deg);\n      }\n\n      @media (max-width: 1200px) {\n        width: 100%;\n        justify-content: space-between;\n        font-size: 17px;\n        padding: 14px 0;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.03);\n      }\n    }\n\n    &-menu {\n      position: absolute;\n      top: calc(100% + 8px);\n      left: 50%;\n      transform: translateX(-50%) translateY(10px);\n      width: 240px;\n      background: $color-surface;\n      border-radius: 16px;\n      box-shadow: 0 10px 30px rgba(18, 34, 29, 0.08);\n      border: 1px solid rgba(19, 35, 29, 0.05);\n      padding: 8px;\n      z-index: 1000;\n      opacity: 0;\n      visibility: hidden;\n      transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;\n\n      &--open {\n        opacity: 1;\n        visibility: visible;\n        transform: translateX(-50%) translateY(0);\n      }\n\n      a,\n      button {\n        display: block;\n        width: 100%;\n        text-align: left;\n        padding: 10px 14px;\n        color: $text-main;\n        font-size: 14px;\n        font-weight: 600;\n        border-radius: 10px;\n        text-decoration: none;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.2s ease, color 0.2s ease;\n\n        &:hover {\n          background-color: rgba($color-primary, 0.06) !important;\n          color: $color-primary !important;\n        }\n      }\n\n      @media (pointer: coarse) {\n        position: static;\n        transform: none;\n        width: 100%;\n        box-shadow: none;\n        border: none;\n        background: transparent;\n        padding: 0 0 0 16px;\n        height: 0;\n        overflow: hidden;\n        transition: height 0.25s ease, padding 0.25s ease;\n\n        &--open {\n          height: auto;\n          transform: none;\n          padding-top: 4px;\n          padding-bottom: 8px;\n        }\n\n        a,\n        button {\n          font-size: 15px;\n          padding: 10px 0;\n          border-bottom: none;\n\n          &:hover {\n            background-color: transparent !important;\n          }\n        }\n      }\n    }\n\n    /* Vistas responsivas en Drawer */\n    &-footer {\n      display: none;\n\n      @media (max-width: 1200px) {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        margin-top: 32px;\n        padding-top: 24px;\n        border-top: 1px solid rgba(0, 0, 0, 0.06);\n        gap: 20px;\n      }\n    }\n\n    &-mobile-lang {\n      display: flex;\n      gap: 12px;\n    }\n\n    &-lang-btn {\n      flex: 1;\n      padding: 10px;\n      border-radius: 10px;\n      border: 1px solid rgba($color-primary, 0.2);\n      background: transparent;\n      color: $text-main;\n      font-weight: 700;\n      font-size: 13px;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &--active {\n        background: rgba($color-primary, 0.1);\n        border-color: $color-primary;\n        color: $color-primary;\n      }\n    }\n\n    &-mobile-user {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    &-user-info {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n      padding-bottom: 16px;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n      min-width: 0;\n    }\n\n    &-user-icon {\n      width: 48px;\n      height: 48px;\n      min-width: 48px;\n      min-height: 48px;\n      max-width: 48px;\n      max-height: 48px;\n      border-radius: 50%;\n      object-fit: cover;\n      flex-shrink: 0;\n      font-size: 48px !important;\n    }\n\n    &-user-details {\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n      flex: 1;\n      overflow: hidden;\n    }\n\n    &-user-name {\n      font-weight: 800;\n      font-size: 16px;\n      color: $text-main;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &-user-email {\n      font-size: 13px;\n      color: $text-secondary;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &-user-actions {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n    }\n\n    &-user-link {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 12px;\n      border-radius: 12px;\n      font-weight: 600;\n      font-size: 15px;\n      color: $text-main;\n      text-decoration: none;\n      transition: background 0.2s;\n\n      svg {\n        font-size: 20px;\n      }\n\n      &:hover {\n        background: rgba($color-primary, 0.05);\n      }\n    }\n\n    &-logout {\n      border: none;\n      background: transparent;\n      width: 100%;\n      color: $text-main;\n      justify-content: center;\n\n      &:hover {\n        background: #FEF2F2 !important;\n      }\n    }\n\n    &-mobile-auth {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    &-login-btn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 46px;\n      font-weight: 700;\n      color: $text-main;\n      text-decoration: none;\n      font-size: 15px;\n    }\n  }\n\n  .actions {\n    width: 388px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    justify-self: end;\n    gap: 22px;\n    white-space: nowrap;\n\n    @media (max-width: 1100px) {\n      width: 348px;\n      gap: 18px;\n    }\n\n    @media (max-width: 1200px) {\n      display: none;\n    }\n  }\n\n  .lang-switch {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: transparent;\n    border: none;\n    padding: 5px;\n    padding-right: 0px;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: $text-main;\n    font-weight: 600;\n    font-size: 15px;\n\n    img {\n      width: 16px;\n      height: 16px;\n      opacity: .78;\n    }\n\n    &--active {\n      background: rgba($color-primary, 0.08);\n    }\n  }\n\n  /* Enlace Acceder */\n  .login-link {\n    font-size: 16px;\n    line-height: 1.2;\n    color: $text-main;\n    font-weight: 600;\n    text-decoration: none;\n  }\n\n  /* Botones principales y CTA */\n  .header-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 46px;\n    padding: 0 20px;\n    border-radius: 16px;\n    background: transparent;\n    border: 1px solid rgba(130, 177, 148, 0.95);\n    color: $color-primary;\n    font-weight: 600;\n    font-size: 15px;\n    text-decoration: none;\n    transition: all 0.24s ease;\n    line-height: 1;\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.10);\n      box-shadow: 0 8px 20px rgba(130, 177, 148, 0.12);\n      transform: translateY(-1px);\n    }\n  }\n\n  /* 5. REGLAS DE INTERACCIÓN VISUAL EN V6 (HOVER LIMPIO Y PLANO) */\n  & .nav a:hover,\n  & .nav a:focus-visible,\n  & .login-link:hover,\n  & .login-link:focus-visible,\n  & .lang-switch:hover,\n  & .lang-switch:focus-visible,\n  & .header-btn:hover,\n  & .header-btn:focus-visible {\n    color: var(--primary) !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    transform: none !important;\n    text-decoration: none !important;\n  }\n\n  /* Botón Toggler para responsivo */\n  .toggler {\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    display: none;\n    color: $text-main;\n\n    @media (max-width: 1200px) {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  &__overlay {\n    position: fixed;\n    inset: 0;\n    background: rgb(19 35 29 / 78%);\n    backdrop-filter: blur(4px);\n    z-index: 1000;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s;\n    pointer-events: none;\n\n    &--is-open {\n      opacity: 1;\n      visibility: visible;\n      pointer-events: auto;\n      height: 100dvh;\n    }\n  }\n\n  /* Elemento contenedor para dropdowns de acciones */\n  .action-item {\n    position: relative;\n  }\n\n  /* Botón de Perfil de Usuario Logueado */\n  .profile-btn {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: transparent;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: $text-main;\n\n    &--active {\n      background: rgba($color-primary, 0.08);\n    }\n  }\n\n  .profile-icon {\n    font-size: 24px !important;\n  }\n\n  .profile-name {\n    font-weight: 700;\n    font-size: 15px;\n  }\n\n  .arrow {\n    transition: transform 0.2s ease;\n    font-size: 20px !important;\n    opacity: 0.7;\n\n    &--open {\n      transform: rotate(180deg);\n    }\n  }\n\n  /* Dropdowns de usuario / idioma generales */\n  .dropdown {\n    position: absolute;\n    top: calc(100% + 12px);\n    right: 0;\n    width: 273px;\n    background: $color-surface;\n    border-radius: 20px;\n    box-shadow: 0 15px 35px rgba(18, 34, 29, 0.12);\n    border: 1px solid rgba(19, 35, 29, 0.06);\n    padding: 5px;\n    z-index: 1000;\n    transform-origin: top right;\n    animation: dropdownFadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n\n    &--lang {\n      width: 190px;\n    }\n\n    &-header {\n      padding: 12px 16px;\n    }\n\n    &-user-name {\n      margin: 0;\n      font-weight: 800;\n      font-size: 13px;\n      color: $text-main;\n      word-wrap: break-word;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 1;\n    }\n\n    &-user-email {\n      margin: 2px 0 0;\n      font-size: 12px;\n      color: $text-secondary;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: block;\n    }\n\n    &-divider {\n      height: 1px;\n      background: rgba(19, 35, 29, 0.06);\n      margin: 8px 0;\n    }\n\n    &-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 10px 12px;\n      text-decoration: none;\n      color: $text-main;\n      font-size: 14px;\n      font-weight: 600;\n      border-radius: 14px;\n      border: none;\n      background: transparent;\n      width: 100%;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &--active {\n        color: $color-primary !important;\n\n        .dropdown-icon-wrapper {\n          color: $color-primary;\n        }\n      }\n\n      &:hover {\n        background: rgba($color-primary, 0.06);\n      }\n\n      &--logout {\n\n        &:hover {\n            background: rgba(130, 177, 148, 0.06);\n\n          .dropdown-icon-wrapper {\n            color: #EF4444;\n          }\n        }\n      }\n\n      span {\n        flex: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    }\n\n    &-icon-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n\n      svg {\n        font-size: 22px !important;\n      }\n    }\n  }\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}","\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves."],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__FeuvY`,
	"header--scrolled": `Header_header--scrolled__83-LZ`,
	"header-inner": `Header_header-inner__pcjDB`,
	"logo": `Header_logo__ybdca`,
	"nav": `Header_nav__Mqis-`,
	"nav--is-open": `Header_nav--is-open__PHi+x`,
	"nav-header": `Header_nav-header__K6eYQ`,
	"nav-close": `Header_nav-close__n1hSo`,
	"nav-links": `Header_nav-links__jOVzi`,
	"nav-link": `Header_nav-link__1ybBU`,
	"nav-dropdown": `Header_nav-dropdown__bUHwl`,
	"nav-trigger": `Header_nav-trigger__cKz-P`,
	"arrow-icon": `Header_arrow-icon__Yx1Uf`,
	"nav-menu": `Header_nav-menu__L734q`,
	"nav-trigger--active": `Header_nav-trigger--active__V6ATq`,
	"nav-menu--open": `Header_nav-menu--open__CAOck`,
	"nav-footer": `Header_nav-footer__nFxCH`,
	"nav-mobile-lang": `Header_nav-mobile-lang__Iq7qz`,
	"nav-lang-btn": `Header_nav-lang-btn__SFf5A`,
	"nav-lang-btn--active": `Header_nav-lang-btn--active__nhoPp`,
	"nav-mobile-user": `Header_nav-mobile-user__nEFhH`,
	"nav-user-info": `Header_nav-user-info__cZfFm`,
	"nav-user-icon": `Header_nav-user-icon__yTb5w`,
	"nav-user-details": `Header_nav-user-details__MwyYi`,
	"nav-user-name": `Header_nav-user-name__i8yu9`,
	"nav-user-email": `Header_nav-user-email__yOIjh`,
	"nav-user-actions": `Header_nav-user-actions__QorZB`,
	"nav-user-link": `Header_nav-user-link__JKd2j`,
	"nav-logout": `Header_nav-logout__O9RXz`,
	"nav-mobile-auth": `Header_nav-mobile-auth__monXU`,
	"nav-login-btn": `Header_nav-login-btn__kewKo`,
	"actions": `Header_actions__PwT9E`,
	"lang-switch": `Header_lang-switch__YVhli`,
	"lang-switch--active": `Header_lang-switch--active__Fj+lZ`,
	"login-link": `Header_login-link__4mZg1`,
	"header-btn": `Header_header-btn__+OQjl`,
	"toggler": `Header_toggler__n58hD`,
	"header__overlay": `Header_header__overlay__Hd0+k`,
	"header__overlay--is-open": `Header_header__overlay--is-open__AXCef`,
	"action-item": `Header_action-item__EAl9X`,
	"profile-btn": `Header_profile-btn__wfMXZ`,
	"profile-btn--active": `Header_profile-btn--active__GenK8`,
	"profile-icon": `Header_profile-icon__x5+9K`,
	"profile-name": `Header_profile-name__rlWPA`,
	"arrow": `Header_arrow__MMgpm`,
	"arrow--open": `Header_arrow--open__jQ3Rw`,
	"dropdown": `Header_dropdown__gG71Y`,
	"dropdownFadeIn": `Header_dropdownFadeIn__wCOVE`,
	"dropdown--lang": `Header_dropdown--lang__sNo60`,
	"dropdown-header": `Header_dropdown-header__Zw7E8`,
	"dropdown-user-name": `Header_dropdown-user-name__e0cFO`,
	"dropdown-user-email": `Header_dropdown-user-email__ORM7z`,
	"dropdown-divider": `Header_dropdown-divider__Grbiz`,
	"dropdown-item": `Header_dropdown-item__gvbii`,
	"dropdown-item--active": `Header_dropdown-item--active__4k9vZ`,
	"dropdown-icon-wrapper": `Header_dropdown-icon-wrapper__wArFJ`,
	"dropdown-item--logout": `Header_dropdown-item--logout__QrEve`
};
export default ___CSS_LOADER_EXPORT___;
